import type { SkedEnvConfig } from "./types";

const config: SkedEnvConfig = {
  resourceUrl: "https://assets-staging.skedsocial.com/",
  apiBaseUrl: "",
  fbAppId: "326046368486691",
  fbGraphApiVersion: "v25.0",
  fbBusinessLoginAppId: "1869297967078669",
  fbBusinessLoginConfigId: "971128282375082",
  // SKE-4579. The second staging Login Configuration, token type System User
  // (docs/instagram-content-publishing/BISU-META-DASHBOARD-SETUP.md).
  fbBusinessLoginSystemUserConfigId: "1434475838554131",
  sendBirdAppId: "13069A74-7FB0-45D9-BC05-B2DF4F172307",
  amplitudeKey: "a3e1cb4cfcaca82c2ec8603b4734cfbe",
  amplitudeExperimentDeploymentKey: "client-j0cSxUfeAi7Om5UXVt09Tbjyqpp290J9",
  hubspotId: "44300864",
  bingPixelId: "17420662",
  linkedInPartnerId: "478874",
  pinterestTagId: "2613969021991",
  googleAdsId: "AW-992177465",
  ga4MeasurementId: "",
  gtmContainerId: "",
  bugsnagApiKey: "8f449d48646c0c521405dbb8b900217d",
  canvaApiKey: "fG32Ux1dYsPxhWU6QraYRH4x",
  dropboxAppKey: "7cwt9g746b3z3qa",
  chargebeeEnabled: true,
  analyticsEnabled: true,
  observabilityEnabled: true,
  observabilityEndpoint:
    "https://ooingest.skedsocial.com/api/3EL1Eqog80uXqWfhTwamLQQqeWi/v1/traces",
  observabilityHeaders: {
    Authorization:
      "Basic b28taW5nZXN0LWZyb250ZW5kLXN0YWdpbmdAc2tlZHNvY2lhbC5jb206bERQdldzN1dVQ0lycncxdg==",
    organization: "3EL1Eqog80uXqWfhTwamLQQqeWi",
    "stream-name": "default",
  },
  observabilitySampleRate: 1,
  rumClientToken: "rumyNaDatdaWIlzRIkP",
  rumOrgIdentifier: "3EL1Eqog80uXqWfhTwamLQQqeWi",
  rumSessionSampleRate: 100,
  rumSessionReplaySampleRate: 0,
  knockApiKey: "pk_test_cwZtQIrgqDAF2bD2gvqmRsgvippFGbxSdNMCVZkEEkY",
  cesdkAssetsUrl:
    "https://assets-staging.skedsocial.com/resources/build/cesdk-assets",
  googleDriveClientId:
    "981158975333-vohjljfs1jsn9sim09n4op4u5t0qpm40.apps.googleusercontent.com",
  googleDriveAppId: "981158975333",
  pusherApiKey: "5cce5f1404af15286506",
  pusherCluster: "mt1",
  insightsApiBaseUrl: "https://api-insights-staging.skedsocial.com/api",
  insightsShareDomain: "https://insights-share-staging.skedsocial.com",
};

export default config;
